import moment from "moment";
import numeral from "numeral";

export const getTimeStringFormatForm = (time?: string | null) => {
  if (time == null || time == undefined) return null as any;

  return moment(time).format("HH:mm:ss");
};

export const getDateStringFormatForm = (date?: string | null) => {
  if (date == null) return null as any;

  return moment(date).format("yyyy-MM-DD");
};

export const getDateHourStringFormatForm = (date?: string) => {
  if (date == null) return null as any;

  return moment(date).format("yyyy-MM-DD HH:mm:ss");
};

export function fCurrency(number: string | number) {
  // Convertir a número si es string
  const numValue = typeof number === 'string' ? parseFloat(number) : number;
  
  // Verificar si es NaN, null, undefined o un número muy pequeño
  if (isNaN(numValue) || numValue === null || numValue === undefined) {
    return '0.00';
  }
  
  // Si el número es muy pequeño (menor a 0.01), devolver 0.00
  if (Math.abs(numValue) < 0.01) {
    return '0.00';
  }
  
  return numeral(numValue).format('0,0.00');
}

export function fCurrencyND(number: string | number) {
  // Convertir a número si es string
  const numValue = typeof number === 'string' ? parseFloat(number) : number;
  
  // Verificar si es NaN, null, undefined o un número muy pequeño
  if (isNaN(numValue) || numValue === null || numValue === undefined) {
    return '0';
  }
  
  // Si el número es muy pequeño (menor a 0.01), devolver 0
  if (Math.abs(numValue) < 0.01) {
    return '0';
  }
  
  return numeral(numValue).format(Number.isInteger(numValue) ? '0,0' : '0,0.00');
}

export function isNullOrEmpty(value: any): boolean {
  return value == null || value == "";
}

export const translateCellContent = (cellContent: string): string => {
  const translations: { [key: string]: string } = {
      "Sale": "Venta",
      "Opening Declaration": "Apertura de Caja",
      "Tender Declaration": "Declaraciones de Medios de Pago",
      "Remove Tender": "Transacción de Retiros",
      "Deposit": "Depósito",
      "Refund": "Nota de Crédito"
  };

  return translations[cellContent] || cellContent;
};